<div class="relative cursor-pointer">
    <!-- {{disabled}} -->
    <ng-select [disabled]="disabled || is_disabled" [items]="options" [appendTo]="appendTo" bindLabel="title" [(ngModel)]="selectedValues" [multiple]="is_multiple" [clearable]="selectedValues" [disabled]="disabled" (change)="onSelectionChange($event)" [placeholder]="placeholder" [compareWith]="compareFn" class="block w-full text-sm text-gray-900 h-12 rounded-lg">
        <ng-template ng-option-tmp let-item="item">
            <div class="capitalize" title="item.title">{{item.title}}</div>
        </ng-template>
        <ng-template *ngIf="show_email" ng-label-tmp let-item="item">
            <div class="flex flex-col leading-tight">
                <span class="font-semibold text-sm">{{ item.title }}</span>
                <span class="text-xs text-gray-500">{{ item.email }}</span>
            </div>
        </ng-template>
        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="flex flex-wrap gap-1">
                <div *ngFor="let item of items" class="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-md text-sm font-medium flex items-center gap-2">
                    <span class="text-nowrap">{{ item.title }}</span>
                    <button type="button" (click)="clear(item)" class="text-primary focus:outline-none">
                        <i class="bx bx-x text-lg"></i>
                    </button>
                </div>
            </div>
        </ng-template>
    </ng-select>

    <!-- <div *ngIf="is_multiple && selectedValues?.length > 0" class="flex w-full overflow-auto no-scrollbar gap-2 mt-2">
        <div *ngFor="let item of selectedValues" class="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-md text-sm font-medium flex items-center gap-2">
            <span class="text-nowrap">{{ item.title }}</span>
            <button type="button" (click)="removeItem(item)" class="text-primary focus:outline-none">
                <i *ngIf="!disabled && !is_disabled" class="bx bx-x text-lg"></i>
            </button>
        </div>
    </div> -->

    <label *ngIf="label" [for]="label" class="absolute truncate max-w-[97%] bg-white text-gray-900 duration-300 floating-label origin-[0] px-2 pointer-events-none text-sm top-[13px] transform transition-all z-10" [ngClass]="{
            '-translate-y-5 scale-75 text-[rgba(0,0,0,0.6)] left-1': selectedValues?.length != 0, 
            'left-[4px]': selectedValues?.length == 0
        }">
        {{ label }}
        <span *ngIf="control?.hasValidator?.(required_validator)" class="col-span-2 text-red-600">*</span>
    </label>
</div>
<!-- {{value}} -->
<!-- <div *ngIf="control && control.errors && (control.dirty || control.touched)" class="error-messages ">
    <p class="text-red-500" *ngIf="control.errors.required">{{label }} is required.</p>
</div> -->
<div *ngIf="control && control.errors && (control.dirty || control.touched)" class="error-messages">
    <p class="text-red-500 text-sm" *ngIf="control.errors.required && is_multiple == false">Please select a {{ label }}.</p>
    <p class="text-red-500 text-sm" *ngIf="control.errors.required && is_multiple == true">Please select at least one {{ label }}.</p>
    <p class="text-red-500 text-sm" *ngIf="control.errors.invalidSchedulingLevel">
        Scheduling level cannot be greater than number of levels.
    </p>
</div>